module.exports = __webpack_public_path__ + "img/KZQ.be2bc681.jpg";